module.exports = __webpack_public_path__ + "static/media/GuideCollectionPageOS10Step1.39aeed19.gif";